export enum Appearance {
  Light,
  Dark,
}
